<template>
  <transition name="fade">
    <u-message
      v-if="showWarningNotes"
      :key="$_.get(basketData, 'basketHash')"
      type="is-caution"
      icon="exclamation-circle"
      :is-processing="isProcessing"
    >
      <strong>{{ $t("_sentence.basket_changed_warning_msg") }}</strong>
      <ul class="basket-warnings">
        <li v-for="(note, index) in warningNotes" :key="`note-${index}`">
          {{ note.message }} -
          <datetime :datetime="note.created_at" />
        </li>
      </ul>
      <u-link slot="action" :disabled="isProcessing" @click="hideNotifications">
        <strong>{{ $t("_action.dismiss") }}</strong>
      </u-link>
    </u-message>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Context from "@/mixins/context";
import type {
  IBasketProviderData
  // IBasketProviderMethods
} from "@/models/providers/baskets";

export default defineComponent({
  name: "BasketNotifications",
  mixins: [Context],
  inject: {
    $basketData: { from: "basketProviderData" },
    $basketMethods: { from: "basketProviderMethods" }
  },
  data: () => ({
    isProcessing: false
  }),
  computed: {
    basketData(): IBasketProviderData {
      return this.$basketData();
    },
    basket() {
      return this.$_.get(this.basketData, "basket");
    },
    showWarningNotes() {
      return (
        !this.$_.isEmpty(this.warningNotes) &&
        !this.$_.get(this.basketData, "basketIsComplete")
      );
    },
    warningNotes() {
      return this.$_.filter(this.$_.get(this.basket, "warning_notes", []), [
        "is_hidden",
        false
      ]);
    }
  },
  methods: {
    async hideNotifications() {
      this.isProcessing = true;
      await this.$basketMethods.hideWarnings(
        this.warningNotes.map(note => note.id)
      );
      this.isProcessing = false;
    }
  }
});
</script>

<style lang="scss" scoped>
.basket-warnings {
  margin-left: 1.5rem;
  list-style-type: disc;
}
</style>
